<div id="layout-breadcrumb" class="layout-breadcrumb no-print" [ngStyle]="app?.isContentFullScreen ? {'padding-top': '0'} : {}">
    <ul>
        <li><a [routerLink]="caminhoPaginaInicial"><i class="material-icons">home</i></a></li>
        <li>/</li>
        <ng-template ngFor let-item let-last="last" [ngForOf]="items">
            <li>
                <a [routerLink]="item.routerLink" *ngIf="item.routerLink">{{item.label}}</a>
                <ng-container *ngIf="!item.routerLink">{{item.label}}</ng-container>
            </li>
            <li *ngIf="!last">/</li>
        </ng-template>
    </ul>

    <div class="layout-breadcrumb-options">
        <!-- FORM EXTRA ACTIONS -->
        <ng-template ngFor let-item [ngForOf]="menuConfig?.getExtraButtonList()">
            <a *ngIf="item.visible"
                (click)="item.command($event)"
                title="{{item.title}}"
                style="cursor: pointer;"> <!--padding: 0 10px; margin: 0 10px;-->
                <i *ngIf="item.mat_icon" class="material-icons">{{item.mat_icon}}</i>
                <i *ngIf="item.fa_icon" class="{{item.fa_icon}}"></i>
                <span class="menuitem-badge" *ngIf="item.badge">{{item.badge}}</span>
                {{item.label}}
                <!-- <span *ngIf="item.mat_icon">
                    <i class="material-icons">{{item.mat_icon}}</i>
                </span> -->
            </a>
        </ng-template>


        <!-- FORM DEFAULT ACTIONS -->
        <a *ngIf="menuConfig?.showFiltrar" title="Filtrar..." (click)="filtrar(menuConfig?.filterController)" style='cursor: pointer;'>
          <i class="material-icons">search</i>
        </a>
        <a *ngIf="menuConfig?.showImprimir" title="Imprimir..." (click)="imprimir()" style="cursor: pointer;">
          <i class="material-icons">print</i>
        </a>
        <a *ngIf="menuConfig?.showNovo" title="Novo..." style='cursor: pointer;'
           [routerLink]="menuConfig?.btNovoRouterLink">
          <i class="material-icons">add</i>
        </a>
        <a *ngIf="menuConfig?.showSalvar" title="Salvar..." (click)="salvar()" style='cursor: pointer;'>
          <i class="material-icons">save</i>
        </a>
        <a *ngIf="menuConfig?.showExcluir" title="Excluir..." (click)="excluir()" style='cursor:pointer;'>
          <i class="material-icons">delete</i>
        </a>
        <a *ngIf="menuConfig?.showVoltar" title="Voltar..." (click)="voltar()" style='cursor:pointer;'>
          <i class="material-icons">arrow_back</i>
        </a>
    </div>
</div>
